import { CtaButton } from '@tkww/orion-web-ds-action';
import { useAtomValue } from 'jotai';
import React, { type FC } from 'react';
import { areStarRatingsSavedAtom } from '../../../../atoms';
import { useStarReviews } from '../../../../hooks/use-star-reviews';
import Styles from './styles.scss';

interface FooterProps {
	handleClose?: () => void;
}

const Footer: FC<FooterProps> = (props) => {
	const { handleClose } = props;
	const areStarRatingsSaved = useAtomValue(areStarRatingsSavedAtom);
	const { handleSave } = useStarReviews(handleClose);

	return (
		<div className={Styles.ctaContainer}>
			<CtaButton
				onClick={handleSave}
				disabled={areStarRatingsSaved}
				className={Styles.ctaButton}
				block="sm"
				styleType="primary"
			>
				Show reviews
			</CtaButton>
		</div>
	);
};

export { Footer };
